import { render, staticRenderFns } from "./BulkJobCreate.vue?vue&type=template&id=62251b9b&scoped=true"
import script from "./BulkJobCreate.vue?vue&type=script&lang=ts"
export * from "./BulkJobCreate.vue?vue&type=script&lang=ts"
import style0 from "./BulkJobCreate.vue?vue&type=style&index=0&id=62251b9b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62251b9b",
  null
  
)

export default component.exports